import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {
  FetchSideNavWeeksListModel
} from "../models/fetch-side-nav-weeks-list.model";
import {FetchWeeksListModel} from "../models/fetch-weeks-list.model";
import {FetchResourceListModel} from "../models/fetch-resource-list.model";
import {FetchWeekSummaryModel} from "../models/fetch-week-summary.model";
import {v1URL} from "../../../shared/constants/urls.constants";
import {CommonService} from "../../../shared/services/common.service";
import {UpdateDailyScoreModel} from "../models/update-daily-score.model";

@Injectable({
  providedIn: 'root',
})

export class BehaviorTrackerService {
  constructor(
    private commonServices: CommonService
  ) {
  }

  fetchSideNavWeeksList(payload: FetchSideNavWeeksListModel['request']): Observable<FetchSideNavWeeksListModel['response']> {
    const urlConfig = v1URL.sideNavWeeksList.fetchAll
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchWeeksList(payload: FetchWeeksListModel['request']): Observable<FetchWeeksListModel['response']> {
    const urlConfig = v1URL.weekListSummary.fetch
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchResourceList(payload: FetchResourceListModel['request']): Observable<FetchResourceListModel['response']> {
    const urlConfig = v1URL.resourceHub.list
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  fetchWeekSummary(payload: FetchWeekSummaryModel['request']): Observable<FetchWeekSummaryModel['response']> {
    const urlConfig = v1URL.weekDetails.fetch
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  updateDailyScore(payload: UpdateDailyScoreModel['request']): Observable<UpdateDailyScoreModel['response']> {
    const urlConfig = v1URL.behaviourTracker.score
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }
}
